// Dependencies
import { FC, MouseEventHandler } from "react";

// Components
import { Typography } from "@mui/material";
import { Button } from "~/components/Common";
import { WarningButton } from "~/components/Common/Button";

// Icons
import DeleteIcon from "~/assets/icons/litter.png";

// Styles
import {
  StyledIcon,
  StyledWrapper,
  StyledDeleteAction,
} from "./LayoutDelete.style";

interface LayoutDeleteProps {
  title: string;
  name: string | undefined;
  onCancel: MouseEventHandler<HTMLButtonElement>;
  onConfirm: MouseEventHandler;
}

const LayoutDelete: FC<LayoutDeleteProps> = ({
  title,
  name,
  onCancel,
  onConfirm,
}) => {
  return (
    <StyledWrapper>
      <StyledIcon src={DeleteIcon} />
      <Typography variant={"h2"}>{title}</Typography>
      <Typography variant={"h3"}>{name}</Typography>
      <StyledDeleteAction>
        <Button variant={"contained"} onClick={onCancel}>
          Cancel
        </Button>
        <WarningButton onClick={onConfirm}>Delete</WarningButton>
      </StyledDeleteAction>
    </StyledWrapper>
  );
};

export default LayoutDelete;
